<template>
	<div class="catalog-sidebar" id="car">
		<div class="catalog-sidebar-top">
			<div class="catalog-sidebar-top-title" :style="`color: ${theme.warning};`">
				SU PEDIDO
			</div>
			<div class="catalog-sidebar-top-car">
				<span
					class="catalog-sidebar-top-car-quantity"
					:style="`background-color: ${theme.primary}; color: ${theme.base};`"
				>
					{{ quantity }}
				</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="25"
					height="24"
					viewBox="0 0 25 24"
					class="catalog-sidebar-top-car-image"
				>
					<g :fill="theme.secondary">
						<path stroke="#FFF" stroke-width=".3" d="M19.167 16.152c-1.664 0-3.018 1.354-3.018 3.018 0 1.665 1.354 3.019 3.018 3.019 1.665 0 3.019-1.354 3.019-3.019 0-1.664-1.354-3.018-3.019-3.018zm0 4.226c-.666 0-1.207-.542-1.207-1.208 0-.666.541-1.207 1.207-1.207s1.208.541 1.208 1.207-.542 1.208-1.208 1.208z" transform="translate(0 .778)"/>
						<path d="M24.015 4.486c-.171-.22-.434-.348-.712-.348H5.59L4.775.728C4.677.321 4.313.033 3.894.033H.906C.406.033 0 .44 0 .94s.405.905.906.905h2.273l2.943 12.314c.098.408.462.696.88.696H21.1c.416 0 .78-.284.879-.688l2.204-8.904c.066-.27.005-.557-.167-.776zm-3.624 8.557H7.718L6.022 5.949h16.123l-1.754 7.094z" transform="translate(0 .778)"/>
						<path stroke="#FFF" stroke-width=".3" d="M8.21 16.152c-1.664 0-3.018 1.354-3.018 3.018 0 1.665 1.354 3.019 3.018 3.019 1.665 0 3.019-1.354 3.019-3.019 0-1.664-1.354-3.018-3.019-3.018zm0 4.226c-.666 0-1.207-.542-1.207-1.208 0-.666.541-1.207 1.207-1.207s1.208.541 1.208 1.207-.542 1.208-1.208 1.208z" transform="translate(0 .778)"/>
					</g>
				</svg>
			</div>
		</div>
		<div class="catalog-sidebar-summary">
			<div class="catalog-sidebar-summary-products">
				<div
					class="catalog-sidebar-summary-products-item"
					:style="`background-color: ${theme.base};`"
					v-for="product in productsSelected"
					:key="product.id"
				>
					<span
						class="span-quantity"
						:style="`background-color: ${theme.primary}; color: ${theme.base};`"
					>
						{{ product.quantity }}
					</span>
					<div class="block-text">
						<span>
							{{ product.unitCode }} {{ product.name }}
						</span>
					</div>
					<span class="span-price">
						<span class="span-price-small">
							{{ currency }}
						</span>
						{{ getPrices(product).priceWithoutDecimals }}.<span class="span-price-small">{{ getPrices(product).priceDecimals }}</span>
					</span>
					<button
						class="btn-delete"
						:style="`border-color: ${theme.secondary}`"
						type="button"
						@click="$emit('delete-product', product)"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							height="6px"
							viewBox="0 0 329.26933 329"
							width="6px"
						>
							<g>
								<path
									d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"
									data-original="#000000"
									class="active-path"
									data-old_color="#000000"
									:fill="theme.secondary"
								/>
							</g>
						</svg>
					</button>
				</div>
				<div class="catalog-sidebar-summary-data">
					<div class="catalog-sidebar-summary-subtotal" :style="`border-color: ${theme.info}`">
						<p>Subtotal:</p>
						<p>{{ currency }} {{ subtotal | round }}</p>
					</div>
					<div class="catalog-sidebar-summary-delivery">
						<p>Envío:</p>
						<p>{{ currency }} {{ delivery | round }}</p>
					</div>
				</div>
			</div>
			<div class="catalog-sidebar-summary-total" :style="`color: ${theme.secondary};`">
				Total: {{ currency }} {{ subtotal + delivery | round }}
				<div
					v-if="!delivery && !pickupSelected"
					class="catalog-sidebar-alert catalog-sidebar-alert-primary mt-2"
					:style="`color: ${theme.secondary};`"
				>
					No incluye costo de envío
				</div>
			</div>
		</div>
		<div class="catalog-sidebar-form">
			<div class="catalog-sidebar-form-item">
				<div class="catalog-sidebar-form-label" :style="`color: ${theme.secondary};`">
					Nombre
				</div>
				<input
					class="catalog-sidebar-form-field catalog-sidebar-form-input"
					placeholder="Ingresa tu nombre completo"
					type="text"
					:value="form.name"
					@input="$emit('get-field-data', { model: 'name', value: $event.target.value })"
				/>
			</div>
			<div class="catalog-sidebar-form-item">
				<div class="catalog-sidebar-form-label" :style="`color: ${theme.secondary};`">
					Celular
				</div>
				<input
					class="catalog-sidebar-form-field catalog-sidebar-form-input"
					placeholder="Ingresa tu número de celular"
					type="number"
					:value="form.phone"
					@input="$emit('get-field-data', { model: 'phone', value: $event.target.value })"
				/>
			</div>
			<div class="catalog-sidebar-form-item">
				<div class="catalog-sidebar-form-label" :style="`color: ${theme.secondary};`">
					Método de pago
				</div>
				<select
					class="catalog-sidebar-form-field catalog-sidebar-form-select"
					:value="form.paymentMethod"
					@input="$emit('get-field-data', { model: 'paymentMethod', value: $event.target.value })"
				>
					<option
						v-for="paymentMethod in paymentMethods"
						:key="paymentMethod.wayPaymentId"
						:value="paymentMethod.name"
					>
						{{ paymentMethod.name }}
					</option>
				</select>
			</div>
			<div class="catalog-sidebar-form-item">
				<div class="catalog-sidebar-form-label" :style="`color: ${theme.secondary};`">
					Dirección de envío
				</div>
				<input
					class="catalog-sidebar-form-field catalog-sidebar-form-input"
					placeholder="Ingresa tu dirección exacta"
					type="text"
					:value="form.address"
					@input="$emit('get-field-data', { model: 'address', value: $event.target.value })"
				/>
			</div>
			<div class="catalog-sidebar-form-item">
				<div class="catalog-sidebar-form-label" :style="`color: ${theme.secondary};`">
					Información adicional
				</div>
				<textarea
					class="catalog-sidebar-form-field catalog-sidebar-form-textarea"
					placeholder="Escribe aquí"
					:value="form.additionalInformation"
					@input="$emit('get-field-data', { model: 'additionalInformation', value: $event.target.value })"
				></textarea>
			</div>
			<div class="catalog-sidebar-form-options" :style="`color: ${theme.warning};`">
				<button
					v-if="showTypeDelivery('EAD')"
					class="catalog-sidebar-form-options-item"
					:class="{ 'active' : gpsSelected }"
					type="button"
					@click="$emit('get-shipping-type', 'gpsSelected')"
				>
					<span
						class="catalog-sidebar-form-options-item-btn"
						:style="gpsSelected ? `background-color: ${theme.warning};` : ''"
					></span>
					<label class="catalog-sidebar-form-options-item-label">
						Incluir mi ubicación GPS
					</label>
				</button>
				<button
					v-if="showTypeDelivery('RCT')"
					class="catalog-sidebar-form-options-item"
					type="button"
					:class="{ 'active' : pickupSelected }"
					@click="$emit('get-shipping-type', 'pickupSelected')"
				>
					<span
						class="catalog-sidebar-form-options-item-btn"
						:style="pickupSelected ? `background-color: ${theme.warning};` : ''"
					></span>
					<label class="catalog-sidebar-form-options-item-label">
						Lo recogeré en el establecimiento
					</label>
				</button>
			</div>
			<div
				v-if="showAmountMin"
				class="catalog-sidebar-alert catalog-sidebar-alert-error"
				:style="`background-color: rgba(${theme.error}, .1); color: ${theme.error};`"
			>
				*El monto mínimo de pedido es {{ currency }}{{ amountMin | round }}
			</div>
			<a :disabled="disabled" :href="`${whatsappLink}text=${whatsappMessage}`" target="_blank">
				<button
					class="catalog-sidebar-form-button"
					:disabled="disabled"
					:style="`background-color: ${theme.accent}; color: ${theme.base};`"
					type="button"
					@click="$emit('send-whatsapp')"
				>
					<template v-if="loading">
						<div class="loading-location">
							<div class="sk-circle">
								<div class="sk-circle1 sk-child"></div>
								<div class="sk-circle2 sk-child"></div>
								<div class="sk-circle3 sk-child"></div>
								<div class="sk-circle4 sk-child"></div>
								<div class="sk-circle5 sk-child"></div>
								<div class="sk-circle6 sk-child"></div>
								<div class="sk-circle7 sk-child"></div>
								<div class="sk-circle8 sk-child"></div>
								<div class="sk-circle9 sk-child"></div>
								<div class="sk-circle10 sk-child"></div>
								<div class="sk-circle11 sk-child"></div>
								<div class="sk-circle12 sk-child"></div>
							</div>
						</div>
					</template>
					<template v-else>
						<span class="catalog-sidebar-top-car">
							<span
								class="catalog-sidebar-top-car-quantity"
								:style="`background-color: ${theme.primary}; color: ${theme.base};`"
							>
								{{ quantity }}
							</span>
							<img
								class="catalog-sidebar-top-car-image"
								src="/static/images-new/icons/icon-car.svg"
								alt="carrito de compras"
								height="24"
							/>
						</span>
						<span>Enviar pedido por whatsapp</span>
					</template>
				</button>
			</a>
		</div>
		<div class="catalog-sidebar-form-share" :style="`color: ${theme.warning};`">
			<span>Comparte:</span>
			<a
				:href="`${whatsappLinkShare}text=${whatsappShareMessage}`"
				target="_blank"
				rel="noopener noreferrer"
			>
				<button
					class="catalog-sidebar-form-share-btn"
					type="button"
				>
					<img
						src="/static/images-new/icons/whatsapp.svg"
						alt="whatsapp"
						height="41"
					/>
				</button>
			</a>
			<a
				:href="`https://www.facebook.com/sharer/sharer.php?u=${facebookMessage}`"
				target="_blank"
				rel="noopener noreferrer"
			>
				<button
					class="catalog-sidebar-form-share-btn"
					type="button"
				>
					<img
						src="/static/images-new/icons/facebook.svg"
						alt="facebook"
						height="41"
					/>
				</button>
			</a>
		</div>
	</div>
</template>

<script>
	function getPrices({ price, quantity }) {
		const priceFixed = (quantity * price).toFixed(2);
		const priceItems = priceFixed.split('.');
		return {
			priceWithoutDecimals: priceItems[0],
			priceDecimals: priceItems[1],
		};
	}

	function showTypeDelivery(code) {
		if (this.deliveryType && this.deliveryType.length > 0) {
			return this.deliveryType.find(dt => dt.code === code);
		}
		return true;
	}

	export default {
		name: 'catalog-sidebar',
		methods: {
			getPrices,
			showTypeDelivery,
		},
		props: {
			amountMin: [Number, String],
			currency: String,
			delivery: [Number, String],
			deliveryType: {
				default: () => [],
				type: Array,
			},
			disabled: {
				default: true,
				type: Boolean,
			},
			form: {
				default: () => {},
				type: Object,
			},
			gpsSelected: {
				default: false,
				type: Boolean,
			},
			facebookMessage: String,
			loading: {
				default: false,
				type: Boolean,
			},
			paymentMethods: {
				default: () => [],
				type: Array,
			},
			pickupSelected: {
				default: false,
				type: Boolean,
			},
			productsSelected: {
				default: () => [],
				type: Array,
			},
			quantity: [Number, String],
			showAmountMin: {
				default: false,
				type: Boolean,
			},
			subtotal: [Number, String],
			theme: {
				default: () => {},
				type: Object,
			},
			whatsappLink: String,
			whatsappLinkShare: String,
			whatsappMessage: String,
			whatsappShareMessage: String,
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-sidebar {
		background-color: #f5fbfb;
		border-radius: 16px;
		height: fit-content;
		height: -moz-fit-content;
		max-width: 346px;
		position: relative;
		width: 100%;

		&-top {
			padding-top: 33px;
			text-align: center;

			&-title {
				font-size: size(large);
				font-weight: weight(semibold);
			}

			&-car {
				display: none;
				position: absolute;
				right: 17px;
				top: 19px;

				&-quantity {
					align-items: center;
					border-radius: 100%;
					display: flex;
					font-size: size(caption);
					font-weight: weight(semibold);
					height: 23px;
					justify-content: center;
					position: absolute;
					right: 0px;
					top: 0px;
					width: 23px;
				}

				&-image {
					margin-right: 14px;
					margin-top: 5px;
				}

				@media (min-width: 740px) {
					display: initial;
				}
			}
		}

		&-summary {
			&-products {
				color: #a6a6a6;
				padding: 15px 0px;

				&-item {
					align-items: center;
					border-radius: 16px;
					color: #494949;
					display: flex;
					margin: 6px 8px;
					padding: 10px;

					.p-bold {
						font-size: 12px;
						font-weight: weight(bold);
						margin: 0px;
						width: 100%;
					}

					.span-quantity {
						align-items: center;
						border-radius: 100%;
						display: inline-flex;
						font-size: 12px;
						font-weight: weight(semibold);
						height: 23px;
						justify-content: center;
						min-width: 23px;
						width: 23px;
					}

					.block-text {
						padding-left: 14px;
						max-width: calc(100% - 110px);
						width: calc(100% - 110px);
					}

					.span-price {
						background-color: rgba(#8f8f8f, .15);
						border-radius: 5px;
						color: #494949;
						font-size: 20px;
						font-weight: weight(bold);
						height: 32px;
						min-width: fit-content;
						min-width: -moz-fit-content;
						padding: 0px 10px;

						&-small {
							font-size: 12px;
						}
					}
				}
			}

			&-data {
				display: flex;
				justify-content: center;
				padding-top: 20px;
			}

			&-subtotal,
			&-delivery {
				display: inline-block;
				font-size: size(medium18);
				font-weight: weight(heavy);
				text-align: center;
				
				p {
					margin: 0px;
				}
			}

			&-subtotal {
				border-right-style: solid;
				border-right-width: 1px;
				max-width: fit-content;
				max-width: -moz-fit-content;
				padding-right: 41px;
			}

			&-delivery {
				max-width: fit-content;
				max-width: -moz-fit-content;
				padding-left: 44px;
			}

			&-total {
				background-color: #ecf7f7;
				font-size: size(large);
				font-weight: weight(heavy);
				padding-bottom: 22px;
				padding-top: 17px;
				text-align: center;
			}
		}

		&-form {
			padding: 34px 25px 37px;

			&-label {
				font-size: 10px;
				margin-bottom: 5px;
				padding-left: 24px;
			}

			&-field {
				background-color: rgba(215, 237, 238, 0.3);
				border: 1px solid #d7edee;
				border-radius: 25px;
				color: #494949;
				font-size: size(caption);
				font-weight: weight(regular);
				height: 50px;
				margin-bottom: 10px;
				outline: none;
				padding: 0px 24px;
				width: 100%;

				&::placeholder {
					color: #494949;
				}

				&::-moz-placeholder {
					color: #494949;
				}

				&::-webkit-input-placeholder {
					color: #494949;
				}
			}

			&-select {
				background-image: url('/static/images-new/icons/down-arrow.svg');
				background-position: 91% center;
				background-repeat: no-repeat;
				background-size: 15px 20px;
				padding-right: 40px;
			}

			&-textarea {
				height: 78px;
				padding-bottom: 10px;
				padding-top: 10px;
				
				&::-webkit-resizer {
					display: none;
				}
			}

			&-options {
				font-size: size(medium);
				font-weight: weight(bold);

				&-item {
					align-items: center;
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					margin-bottom: 18px;
					width: 100%;

					&-btn {
						background-color: #ecf7f7;
						border: 1px solid #d7edee;
						border-radius: 100%;
						display: inline-block;
						height: 30px;
						margin-right: 8px;
						padding-top: 2px;
						width: 30px;
					}

					&.active {
						.catalog-sidebar-form-options-item-btn:before {
							border-bottom: 3px solid #ffffff;
							border-right: 3px solid #ffffff;
							content: '';
							display: inline-block;
							height: 14px;
							margin-top: 4px;
							transform: rotate(45deg);
							width: 6px;
						}
					}

					&-label {
						text-align: left;
						width: calc(100% - 40px);
					}
				}
			}

			&-button {
				border-radius: 22px;
				font-size: size(medium16);
				font-weight: weight(semibold);
				height: 50px;
				margin-top: 17px;
				position: relative;
				width: 100%;

				.catalog-sidebar-top-car {
					bottom: auto;
					left: auto;
					margin-left: 11px;
					margin-right: 11px;
					position: relative;
					right: auto;
					top: auto;
				}
			}

			&-share {
				background-color: #ecf7f7;
				border-bottom-left-radius: 16px;
				border-bottom-right-radius: 16px;
				font-size: size(medium18);
				font-weight: weight(semibold);
				padding: 27px 0px 30px;
				text-align: center;

				&-btn {
					&:first-of-type {
						margin-left: 27px;
						margin-right: 41px;
					}
				}
			}
		}

		&-alert {
			border: 1px solid currentColor;
			border-radius: 19px;
			font-size: 14px;
			font-weight: weight(heavy);
			line-height: normal;
			margin: 0 auto;
			max-width: fit-content;
			max-width: -moz-fit-content;
			padding: 6px 20px;
		}
	}

	.btn-delete {
		align-items: center;
		border-style: solid;
		border-width: 1px;
		border-radius: 100%;
		display: inline-flex;
		height: 17px;
		justify-content: center;
		margin-left: auto;
		width: 17px;
	}

	.loading-location {
		height: 30px;
		margin-bottom: 0px;
		position: relative;
		width: 100%;
	}

	.sk-circle {
		bottom: 0px;
		height: 20px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 20px;
	}

	.sk-circle .sk-child {
		height: 100%;
		left: 0;
		position: absolute;
		top: 0;
		width: 100%;
	}

	.sk-circle .sk-child:before {
		background-color: #ffffff;
		border-radius: 100%;
		content: '';
		display: block;
		height: 30%;
		margin: -10px auto;
		width: 30%;
		-webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
				animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
	}

	.sk-circle .sk-circle2 {
		-webkit-transform: rotate(30deg);
			-ms-transform: rotate(30deg);
				transform: rotate(30deg);
	}

	.sk-circle .sk-circle3 {
		-webkit-transform: rotate(60deg);
			-ms-transform: rotate(60deg);
				transform: rotate(60deg);
	}

	.sk-circle .sk-circle4 {
		-webkit-transform: rotate(90deg);
			-ms-transform: rotate(90deg);
				transform: rotate(90deg);
	}

	.sk-circle .sk-circle5 {
		-webkit-transform: rotate(120deg);
			-ms-transform: rotate(120deg);
				transform: rotate(120deg);
	}

	.sk-circle .sk-circle6 {
		-webkit-transform: rotate(150deg);
			-ms-transform: rotate(150deg);
				transform: rotate(150deg);
	}

	.sk-circle .sk-circle7 {
		-webkit-transform: rotate(180deg);
			-ms-transform: rotate(180deg);
				transform: rotate(180deg);
	}

	.sk-circle .sk-circle8 {
		-webkit-transform: rotate(210deg);
			-ms-transform: rotate(210deg);
				transform: rotate(210deg);
	}

	.sk-circle .sk-circle9 {
		-webkit-transform: rotate(240deg);
			-ms-transform: rotate(240deg);
				transform: rotate(240deg);
	}

	.sk-circle .sk-circle10 {
		-webkit-transform: rotate(270deg);
			-ms-transform: rotate(270deg);
				transform: rotate(270deg);
	}

	.sk-circle .sk-circle11 {
		-webkit-transform: rotate(300deg);
			-ms-transform: rotate(300deg);
				transform: rotate(300deg);
	}

	.sk-circle .sk-circle12 {
		-webkit-transform: rotate(330deg);
			-ms-transform: rotate(330deg);
				transform: rotate(330deg);
	}

	.sk-circle .sk-circle2:before {
		-webkit-animation-delay: -1.1s;
				animation-delay: -1.1s;
	}

	.sk-circle .sk-circle3:before {
		-webkit-animation-delay: -1s;
				animation-delay: -1s;
	}

	.sk-circle .sk-circle4:before {
		-webkit-animation-delay: -0.9s;
				animation-delay: -0.9s;
	}

	.sk-circle .sk-circle5:before {
		-webkit-animation-delay: -0.8s;
				animation-delay: -0.8s;
	}

	.sk-circle .sk-circle6:before {
		-webkit-animation-delay: -0.7s;
				animation-delay: -0.7s;
	}

	.sk-circle .sk-circle7:before {
		-webkit-animation-delay: -0.6s;
				animation-delay: -0.6s;
	}

	.sk-circle .sk-circle8:before {
		-webkit-animation-delay: -0.5s;
				animation-delay: -0.5s;
	}

	.sk-circle .sk-circle9:before {
		-webkit-animation-delay: -0.4s;
				animation-delay: -0.4s;
	}

	.sk-circle .sk-circle10:before {
		-webkit-animation-delay: -0.3s;
				animation-delay: -0.3s;
	}

	.sk-circle .sk-circle11:before {
		-webkit-animation-delay: -0.2s;
				animation-delay: -0.2s;
	}

	.sk-circle .sk-circle12:before {
		-webkit-animation-delay: -0.1s;
				animation-delay: -0.1s;
	}

	@-webkit-keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}

	@keyframes sk-circleBounceDelay {
		0%, 80%, 100% {
			-webkit-transform: scale(0);
					transform: scale(0);
		} 40% {
			-webkit-transform: scale(1);
					transform: scale(1);
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-sidebar.vue